export default {
  credits: false,
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
          enabled: false
      },
      showInLegend: true,
      center: ['50%', '80px'],
      size: '90%',
    },
  },
  legend: {
    enabled: true,
    layout: 'vertical',
    itemStyle: {
      color: '#000',
      fontWeight: 'normal',
      fontSize: "12px",
      lineHeight: "18px",
      fontFamily: 'Roboto, "Helvetica Neue",Helvetica,Arial,sans-serif',
    },
    floating: true,
    layout: 'vertical',
    verticalAlign: 'top',
    y: 260,
    itemMarginBottom: 5,
  },
  tooltip: {
    formatter: function () {
      return '<span style="color:'+this.point.color+'">\u25CF</span> ' + this.point.name + '<b>'+ ': ' + this.y + '% </b>';
    },
    style: {
      fontFamily: 'Roboto, "Helvetica Neue",Helvetica,Arial,sans-serif',
    }
  },
  title: {
    style: {
      fontFamily: 'Roboto, "Helvetica Neue",Helvetica,Arial,sans-serif',
    }
  },
  chart: {
    type: 'pie',
  },
  series: {
    colorByPoint: true,
    innerSize: '50%',
  },
};